import Cookies from 'js-cookie';
import CookieFunction from './cookieFunction';

const LoginFunction = (value) => {
  // const { Login,setLogin } =useContext(AdminContext);
  // let tokenValue='eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ0b2tlbiI6ImQxZjBjOWYwLTk3MDItMTFlYy05YzY5LTRkZTAyMDE2Y2UwMCIsImlhdCI6MTY0NTg3OTg5MH0.W6yzplRQZTVytAimj9Ia2pVqAw8OwkgBhG3TRSqmoGwz'
  if (value) {
    window.location.reload();
    // Cookies.set(
    //     'ochattToken',
    //     'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ0b2tlbiI6ImQxZjBjOWYwLTk3MDItMTFlYy05YzY5LTRkZTAyMDE2Y2UwMCIsImlhdCI6MTY0NTg3OTg5MH0.W6yzplRQZTVytAimj9Ia2pVqAw8OwkgBhG3TRSqmoGw'
    //   );
  } else {
    CookieFunction('remove', 'ochattToken');
    CookieFunction('remove', 'userAuthOchatt');
    CookieFunction('remove', 'signup');
    CookieFunction('remove', 'user');
    window.location.reload();
    // setLogin(false)
  }
};
export default LoginFunction;
